<template>
	<v-card flat class="">
		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" class="elevation-1">
			<template v-slot:top>
				<v-toolbar flat>
					<v-toolbar-title>Jadwal Praktik</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-autocomplete v-model="table.id_prodi" :items="table.prodis" outlined dense label="Prodi :"
						item-text="nama" item-value="id" hide-details="" @change="getDataFromApi()"></v-autocomplete>
					<v-select v-model="table.status" outlined hide-details="" dense label="Status :"
						:items="table.statuss" @change="getDataFromApi()"></v-select>
					<v-btn small color="secondary" @click="getDataFromApi()" class="mr-4"><v-icon>{{
						icons.mdiMagnify
					}}</v-icon></v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.institusi="{ item }">
				{{ item.nama_institusi }}/ {{ item.nama_prodi }}
			</template>
			<template v-slot:item.stase="{ item }">
				{{ item.nama_stase }}, {{ item.stase }}
			</template>
			<template v-slot:item.file_url="{ item }">
				<embed type="application/pdf" :src="item.file_url + '#toolbar=0&navpanes=0&scrollbar=0'" width="500"
					height="300" />
				<br /><a target="_blank" :href="item.file_url">Lihat
					File</a>
			</template>
			<template v-slot:item.actions="{ item }">
				<span v-if="item.flag_end == 0">Aktif</span>
				<span v-else>Non Aktif</span>
				<router-link :to="{ name: 'UniversitasPraktikAnggota', params: { id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Lihat</v-btn>
				</router-link>
				<!-- <router-link :to="{ name: 'UniversitasDaftar', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Daftar Hadir</v-btn>
				</router-link> -->
				<!-- <router-link v-if="item.profesi == 'Dokter'"
					:to="{ name: 'UniversitasEvaluasiDokter', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Peserta Didik</v-btn>
				</router-link>
				<router-link v-else-if="item.profesi == 'PPDS'"
					:to="{ name: 'UniversitasEvaluasiPPDS', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Peserta Didik</v-btn>
				</router-link>
				<router-link v-else-if="item.profesi == 'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain'"
					:to="{ name: 'UniversitasEvaluasiLain', params: { praktik_id: item.id } }">
					<v-btn block class="my-2" small color="primary" dark>Evaluasi Peserta Didik</v-btn>
				</router-link> -->
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="getDataFromApi">
					Reload
				</v-btn>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil, mdiMagnify } from '@mdi/js'

export default {
	components: {
		// UploadDokumenRegistrasi,
	},
	data: () => ({
		icons: {
			mdiEye,
			mdiPencil, mdiMagnify
		},
		tableOptions: {},
		table: {
			loading: true,
			headers: [
				{
					text: 'No',
					align: 'start',
					sortable: false,
					value: 'no',
				},
				{ text: 'Institusi/ Prodi', value: 'institusi' },
				{ text: 'Kelompok', value: 'profesi' },
				{ text: 'Stase', value: 'stase' },
				{ text: 'File', value: 'file_url', sortable: false },
				{ text: 'Status/ Aksi', value: 'actions' },
			],
			items: [],
			totalItems: 0,
			status: 'Aktif',
			statuss: ['Aktif', 'Non Aktif'],
			prodis: [],
			id_prodi: 'SEMUA'
		},
		dialog: false,
		// dialogDelete: false,
		form: {
			editedIndex: -1,
			editedItem: {
				id_institusi: '',
				id_prodi: '',
				nama: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			defaultItem: {
				id_prodi: '',
				id_prodi: '',
				nama: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
			},
			profesis: [
				'Dokter',
				'PPDS',
				'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain',
			],
			stases: [],
		},
		institusi_pendidikans: [],
		prodis: [],
	}),
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		formTitle() {
			return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
		},
		user() {
			return this.$store.getters.user
		},
	},
	created() {
		// this.getStase()
		// this.getInstitusiPendidikan()
		this.getProdi()
	},
	methods: {
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('id_institusi', this.user.id_institusi)
			fmData.append('search', '')
			fmData.append('status', this.table.status)
			fmData.append('id_prodi', this.table.id_prodi)
			axiosPostAuth('api/Praktik/getPraktik_datatable', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
		getProdi() {
			axiosGetAuth('api/RegisterLanjutan/getProdis')
				.then(response => {
					if (response.code === 200) {
						this.table.prodis = response.datas
						this.table.prodis.push({
							"id": "SEMUA",
							"nama": "SEMUA"
						})
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
	},
}
</script>